<script>
  import { onMount } from "svelte";

  const text = "working on an awesome new website ";
  const radius = 90;
  let textElement;
  let width = 1;
  let active = false;

  function init() {
    if (!width) return;
    const angle = 360 / text.length;

    Array.from(textElement.children).forEach((child, idx) => {
      child.style.position = "absolute";
      child.style.height = `${radius}px`;
      child.style.transformOrigin = "bottom center";
      child.style.transform = `translate(${width / 2}px, 0px) rotate(${idx * angle}deg)`;
    });
  }

  $: setTimeout(() => {
    width = textElement?.offsetWidth;
    init();
    active = true;
  }, 500);
</script>

<style>
  .circle-text { opacity: 0; }
  .circle-text.active { opacity: 0.2; }
</style>

<div class="circle-text" class:active bind:this={textElement}>
  {#each Array.from(text) as letter}
    <span>{letter}</span>
  {/each}
</div>
